import { render, staticRenderFns } from "./EditTaxonomyClass.vue?vue&type=template&id=599e348f&"
import script from "./EditTaxonomyClass.vue?vue&type=script&lang=js&"
export * from "./EditTaxonomyClass.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports